import { useQuery } from '@apollo/client';
import { useEffect } from 'react';
import { Outlet, useSearchParams } from 'react-router-dom';
import { LoadingPane } from '~/components/loading-pane';
import {
  FolderContextDocument,
  FolderContextProvider,
  findLandingFolderId,
  useAppContext,
} from '~/contexts';

/**
 * Handles the list view on all show pages and makes sure the folder tree context is set.
 * Rewritten to address issues with looping/clearing params
 */
export const ShowsRoot = () => {
  const { currentNetwork } = useAppContext();

  const [searchParams, setSearchParams] = useSearchParams();

  const search = searchParams.get('search')?.trim() || '';
  const backToFolder = searchParams.get('backToFolder')?.trim() || '';

  useEffect(() => {
    const next = new URLSearchParams(searchParams);

    backToFolder ? next.set('backToFolder', backToFolder) : next.delete('backToFolder');
    search ? next.set('search', search) : next.delete('search');

    const current = searchParams.toString();
    const target = next.toString();
    if (current !== target) setSearchParams(next, { replace: true });
  }, [backToFolder, search, setSearchParams, searchParams]);

  const { data, loading } = useQuery(FolderContextDocument, {
    fetchPolicy: 'cache-first',
    variables: { networkId: currentNetwork.id },
  });

  return (
    <LoadingPane in={loading && !data} size={80} thickness={4}>
      {data?.network?.showFolderTree && (
        <FolderContextProvider
          folderTree={data.network.showFolderTree}
          landingFolderId={findLandingFolderId(
            data.network.showFolderTree,
            data.network.showFolders,
          )}
        >
          <Outlet />
        </FolderContextProvider>
      )}
    </LoadingPane>
  );
};
